module.exports = "/162/_next/static/images/rushtrail-logo-19b1dcd54d43cc842e485323bd6f7a31.png";